export const theme = {
  colors: {
    primary: '#000',
    secondary: '#000',
    background: '#f7f7f7',
    cardBackground: '#ff0000',
    cardBorder: '#D0D9E1',
    textPrimary: '#000',
    textSecondary: '#f7f7f7',
  },
  boxShadow: '0 12px 20px rgba(0, 0, 0, 0.5)',
  borderRadius: '12px',
};
